// import dynamic from 'next/dynamic';
import Image from 'next/image';
import cx from 'classnames';
import styles from './FooterSubscription.module.sass';
import FormLoader from '@/components/Modules/Forms/FormLoader';
import Container from '@/components/Container';
import withLazyLoad from '../../hooks/withLazyLoad';

function FooterSubscription() {
    // const inheritContent = inheritPost || inheritPage;
    const regText = 'Get new monthly articles and special invitations in your inbox!';
    // const inheritText = 'Join the Inherit community! Brighten your inbox with monthly article emails and occasional event announcements.';
    // const subscribeFormInherit = inheritContent ? styles.subscribeFormInherit : '';
    // const headerId = inheritContent ? 'inherit-subscribe-form' : '';

    return (
        <div className="footer-subscribe-section post-footer-subscription">
            <div className={cx([`${styles.subscribeForm} bg-yellow dark:bg-darkModeBg print:hidden`])}>
                <Container width="normal">
                    <div className={`${styles.subscribeFormContainer} mx-auto flex flex-wrap-reverse justify-center px-7 py-7 text-left md:px-4 md:pb-0 md:pt-4`}>
                        <div className={cx([`${styles.subscribeFormForm} w-full md:my-auto md:py-7 lg:w-5/12 2xl:w-6/12`])}>
                            <h1 className="mb-2 md:text-left">Subscribe</h1>
                            <p className="mb-5 mt-3 leading-normal md:text-left lg:mt-4">{regText}</p>
                            <FormLoader id="36" footer dynamicParameters={[]} />
                        </div>
                        <div className="w-full md:w-6/12 lg:w-7/12 2xl:w-5/12">
                            <div className="mx-auto max-w-[325px] pb-5 pl-0 md:max-w-none md:pb-0">
                                <Image src={`/images/line_drawing-man_reading_paper.png`} className="dark:invert" alt={'Man reading paper'} width="475" height="511" />
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
            <style>{`
                .footer-subscribe-section .submit-button-container {
                    text-align: left;
                }
            `}</style>
        </div>
    );
}

export default withLazyLoad(FooterSubscription);
